export enum VIEW {
  CELLS_LARGE,
  CELLS_SMALL,
  LIST,
}
